// removed by extract-text-webpack-plugin
module.exports = {"svgSize":"ContextualMessage__svgSize","marginTop1":"ContextualMessage__marginTop1","marginTop2":"ContextualMessage__marginTop2","marginTop3":"ContextualMessage__marginTop3","msgPadding":"ContextualMessage__msgPadding","msgMaxWidth":"ContextualMessage__msgMaxWidth","linkColor":"ContextualMessage__linkColor"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/ContextualMessage/ContextualMessage.scss
// module id = 1767
// module chunks = 8